import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `CompanyContacts`,
  name: `CompanyContactsName`,
  more: `CompanyContactsMore`
};

export function useCompanyContactsStyles() {
  const { semanticColors, fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root, fonts.small, {}],
      name: [classNames.name, { lineHeight: `24px` }],
      more: [
        classNames.more,
        {
          color: semanticColors.bodySubtext,
          textAlign: `right`
        }
      ]
    }),
    [fonts, semanticColors]
  );
}
